import { render, staticRenderFns } from "./ProductoUpdate.vue?vue&type=template&id=62ed8c25&scoped=true"
import script from "./ProductoUpdate.vue?vue&type=script&lang=js"
export * from "./ProductoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed8c25",
  null
  
)

export default component.exports